import { CockpitDocumentsGrouped } from '../../CockpitDocumentsGrouped'
import type { ICockpitDocumentsGroupedProps } from '../../types'
import { DocumentsTreeView } from '../documentsTreeView/DocumentsTreeView'

import styles from './DocumentsNavigationView.module.scss'

interface IProps extends ICockpitDocumentsGroupedProps {
  isManagerCockpitMode: boolean
  fullscreen?: boolean
}
export const DocumentsNavigationView = ({
  isManagerCockpitMode,
  fullscreen = false,
  ...props
}: IProps) => (
  <div className={styles.root}>
    {isManagerCockpitMode && fullscreen ? (
      <DocumentsTreeView sections={props.sections} readOnly={props.readOnly} />
    ) : (
      <CockpitDocumentsGrouped {...props} />
    )}
  </div>
)
